module.exports = __webpack_public_path__ + "plat/static/img/subflow.f38e641b.svg";